import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { map, share } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { ISelectionItem } from '@app/models/selection-item';
import { environment } from 'src/environments';
import { LaunchesFilter } from '@app/models/launches-list-item';

@Injectable({ providedIn: 'root' })
export class DatasourcesService {

  public thirdPartyCategories: ISelectionItem[] = null;
  public formSubType: ISelectionItem[] = null;


  public reuseData: boolean = false;

  private apiEndpoint: string;

  constructor(private _http: HttpClient) {
    this.apiEndpoint = environment.apiUrl
  }

  getTagsList() {
    return this._http.get<ISelectionItem[]>(`${this.apiEndpoint}/DataSource/GetTagsList`);
  }

  getAvailableThirdpartyTypes() {
    return this._http.get<ISelectionItem[]>(`${this.apiEndpoint}/DataSource/GetThirdPartyTypeList`).pipe(
      map(res => {
        return res;
      })
    )
  }

  getThirdpartyTypes() {
    return this._http.get<ISelectionItem[]>(`${this.apiEndpoint}/DataSource/GetThirdpartyTypeList`).pipe(
      map(res => {
        return res;
      })
    )
  }

  getFollowUpPlanStatuses() {
    return this._http.get<ISelectionItem[]>(`${this.apiEndpoint}/DataSource/GetFollowUpPlanStatuses`)
      .pipe(
        share(),
      );
  }

  getLevels() {
    return this._http
      .get<ISelectionItem[]>(`${this.apiEndpoint}/DataSource/GetLevels`);
  }

  getCountries() {
    return this._http.get<ISelectionItem[]>(`${this.apiEndpoint}/Datasource/GetCountries`);
  }
  getStatesByCountryId(countryId) {
    return this._http.get<ISelectionItem[]>(`${this.apiEndpoint}/Datasource/GetStatesByCountryId?id=${countryId}`);
  }
  getCitiesByStateId(stateId) {
    return this._http.get<ISelectionItem[]>(`${this.apiEndpoint}/Datasource/GetCitiesByStateId?id=${stateId}`);
  }
  getItemTypes() {
    return this._http.get<ISelectionItem[]>(`${this.apiEndpoint}/Datasource/GetTypesId`);
    // return of([]);
  }
  getThirdPartyTypeList() {
    return this._http.get<ISelectionItem[]>(`${this.apiEndpoint}/Datasource/GetThirdPartyTypeList`);
  }

  getThirdPartyRoles() {
    return this._http.get<ISelectionItem[]>(`${this.apiEndpoint}/Datasource/GetThirdPartyExtRoles`);
  }

  checkIfMustCreateExternalUser() {
    return this._http.get<boolean>(`${this.apiEndpoint}/TenantConfig/MustCreateUser`);
  }

  getAreas(){
    return this._http.get<ISelectionItem[]>(`${this.apiEndpoint}/DataSource/GetAreasList`);
  }

  getActiveSurveyForms(){
    return this._http.get<ISelectionItem[]>(`${this.apiEndpoint}/DataSource/GetActiveSurveyForms`);
  }

  getFormSubType(formTypeId: number){
    return this._http.get<ISelectionItem[]>(`${this.apiEndpoint}/DataSource/GetFormSubType/${formTypeId}`);
  }

  GetForm(formTypeId: number){
    return this._http.get<ISelectionItem[]>(`${this.apiEndpoint}/DataSource/GetForm/${formTypeId}`);
  }

  getSurveyStatus(){
    return this._http.get<ISelectionItem[]>(`${this.apiEndpoint}/DataSource/GetSurveyStatus`);
  }

  getCommercialStatus(){
    return this._http.get<ISelectionItem[]>(`${this.apiEndpoint}/DataSource/GetCommerceStatus`);
  }

  getRecordTypeData(reportTypeId: number){
    return this._http.get<ISelectionItem[]>(`${this.apiEndpoint}/DataSource/GetRecordTypeData/${reportTypeId}`);
  }

  getThirdPartiesManaged(filter: string): Observable<any> {
    const params = new HttpParams().set('filter', filter);
    return this._http.get<any>(`${this.apiEndpoint}/DataSource/GetThirdPartiesManaged`, {params});
  }

  getThirdPartyCategories(): Observable<ISelectionItem[]> {
    return this._http.get<ISelectionItem[]>(`${this.apiEndpoint}/DataSource/GetCategories`);
  }

  getPeriodicities(): Observable<ISelectionItem[]> {
    return this._http
      .get<ISelectionItem[]>(`${this.apiEndpoint}/DataSource/GetPeriodicities`);
  }
  getPeriodicityPreference():Observable<any>{
    return this._http
    .get<any>(`${this.apiEndpoint}/users/GetUserPeriodicityPreference`);
  }

  getAllFECModules(): Observable<ISelectionItem[]> {
    return this._http
      .get<ISelectionItem[]>(`${this.apiEndpoint}/DataSource/GetAllFECModules`);
  }

  getSurveyGenerationStatus(){
    return this._http.get<ISelectionItem[]>(`${this.apiEndpoint}/DataSource/GetSurveyGenerationStatus`);
  }

  getSurveyLaunches(){
    return this._http.get<ISelectionItem[]>(`${this.apiEndpoint}/DataSource/GetSurveyLaunches`);
  }
  
  getConfigEvaluationAutoSave() {
    return this._http.get<any>(`${this.apiEndpoint}/TenantConfig/GetConfigEvaluationAutoSave`);
  }
}
